import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DateGroup } from '@frontend/sports/grid/core/feature/model';
import { IntlService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-date-header',
    template: '<div>{{formatted}}</div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateHeaderComponent implements OnChanges {
    @Input() group: DateGroup;
    @HostBinding('class') className = 'date-group';

    formatted: string;

    constructor(
        private sitecore: Sitecore,
        private intlService: IntlService,
    ) {}

    ngOnChanges(): void {
        if (!this.group) {
            return;
        }

        const current = this.group.date;
        const today = new Date();
        const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

        const equal = (first: Date, second: Date) =>
            first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

        if (equal(today, current)) {
            this.formatted = this.sitecore.globalMessages.NavToday;
        } else if (equal(tomorrow, current)) {
            this.formatted = this.sitecore.globalMessages.Tomorrow;
        } else {
            this.formatted = `${this.intlService.formatDate(current, 'EEEE')} - ${this.intlService.formatDate(current, 'shortDate')}`;
        }
    }
}
